const hideUnhide = (state, action) => ({
  ...state,
  isHidingMaterial: action.status === 'started',
});

export default hideUnhide;
